var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0967 0.757263H3.89733C2.59659 0.757263 1.54102 1.78132 1.54102 3.04234V30.1818C1.54102 31.4446 2.59659 32.47 3.89733 32.47H31.0967C32.3983 32.47 33.461 31.4446 33.461 30.1818V3.04234C33.461 1.78132 32.3983 0.757263 31.0967 0.757263ZM11.008 27.7809H6.27138V12.6473H11.008V27.7809ZM8.63967 10.5781C8.27914 10.5781 7.92215 10.5075 7.58909 10.3704C7.25603 10.2332 6.95343 10.0323 6.69858 9.77891C6.44373 9.52555 6.24163 9.22478 6.10382 8.8938C5.96601 8.56281 5.8952 8.20809 5.89544 7.8499C5.89544 7.12687 6.18454 6.43345 6.69914 5.92219C7.21374 5.41093 7.91169 5.12371 8.63945 5.12371C9.3672 5.12371 10.0652 5.41093 10.5798 5.92219C11.0944 6.43345 11.3835 7.12687 11.3835 7.8499C11.3835 8.57308 11.0945 9.26667 10.58 9.77824C10.0655 10.2898 9.36757 10.5775 8.63967 10.5781ZM28.7395 27.7809H24.0105V20.4218C24.0105 18.6661 23.9759 16.4088 21.5495 16.4088C19.0855 16.4088 18.71 18.3208 18.71 20.2945V27.7814H13.9774V12.6473H18.5194V14.7139H18.5841C19.2163 13.5247 20.7608 12.2699 23.0644 12.2699C27.8551 12.2699 28.74 15.4033 28.74 19.4797L28.7395 27.7809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0260f8cc04eb8296e2b3c8d54ca6a883.svg";
export { ForwardRef as ReactComponent };